var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRightGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.219 13.813c-.188.166-.365.166-.532 0L.157 7.25c-.188-.167-.188-.333 0-.5L6.686.187c.167-.166.344-.166.532 0l.625.625c.166.167.166.344 0 .532L3 6.187h10.656c.25 0 .375.125.375.375v.875c0 .25-.125.375-.375.375H3l4.844 4.844c.166.188.166.365 0 .531l-.625.626z",
    fill: "url(#arrow-right-gradient_svg__paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "arrow-right-gradient_svg__paint0_linear",
    x1: 7.824,
    y1: 42.829,
    x2: 20.613,
    y2: 39.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#01D6B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#218FEE"
  })))));
}

export default SvgArrowRightGradient;